import { render } from "./Cantina.vue?vue&type=template&id=30eb6028"
import script from "./Cantina.vue?vue&type=script&lang=js"
export * from "./Cantina.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__